import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import dataV from "@jiaminghi/data-view";
import Echart from "./components/echart/index.vue";
import EchartAuto from "./components/echart/autoLoopChart.vue";
import EchartAuto2 from "./components/echart/autoLoopChart2.vue";
import EchartAuto3 from "./components/echart/autoLoopChart3.vue";
import MoreUpload from "@/components/upload/moreUpload";
import scroll from "vue-seamless-scroll";
import "element-ui/lib/theme-chalk/index.css";
import * as echarts from "echarts";
import "@/style/font.css";
import "echarts-gl"; // 3d图表库
import "echarts-wordcloud/dist/echarts-wordcloud.js";
import "echarts-wordcloud/dist/echarts-wordcloud.min.js";
// import 'default-passive-events'
import plugins from "./plugins"; // plugins
import nomore from "@/components/nomore.vue";
// 引入接口
import api from "@/API/index.js";
import * as pc from "@/utils/public.js";
import * as ram from "@/utils/token.js";
import "@/style/index.scss";
import "./assets/font/font.css";
import "./permission.js";
import ImageUpload from "@/components/ImageUpload";
import FileUpload from "@/components/FileUpload";
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  // 预加载比例（图片未进入可视区前提前加载的比例）
  preLoad: 1.3,
  // 加载失败时显示的图片地址
  error: "https://file.icve.com.cn/app/6414251338%402x.png",
  // 加载中显示的动画地址
  loading: "https://file.icve.com.cn/app/site/prod/zyzyzx_components/loading.gif",
  // 加载失败重试次数
  attempt: 1,
});
// AI所需组件
// import microApp from "@micro-zoe/micro-app";
// microApp.start()
// import 'amfe-flexible/index.js'
// import '@/assets/js/setRem'
// import JsonExcel from 'vue-json-excel'
// import "@/store/show.js"
Vue.use(ElementUI);
Vue.use(plugins);
Vue.use(dataV);
Vue.use(scroll);
Vue.component("nomore", nomore);
Vue.component("FileUpload", FileUpload);
Vue.component("ImageUpload", ImageUpload);
Vue.component("Echart", Echart);
Vue.component("MoreUpload", MoreUpload);
Vue.component("EchartAuto", EchartAuto);
Vue.component("EchartAuto2", EchartAuto2);
Vue.component("EchartAuto3", EchartAuto3);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
// Vue.component('downloadExcel', JsonExcel)
Vue.prototype.$ram = ram;
Vue.prototype.$api = api;
Vue.prototype.$pc = pc;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
